// Retorno de `aps://uniao/uf` e `aps://uniao/municipio?ufcodigo={codigo}`, anonimos.
// Estas rotas ficam na RAIZ da api, fora de `integracao/`.
// O `codigo` e o do IBGE, e o filtro de municipio e por ele - nao pela sigla.
export type Uf = {
  codigo: string;
  nome: string;
  sigla: string;
};

export type Municipio = {
  codigo: string;
  nome: string;
  uf: Uf;
};

// Retorno de `aps://integracao/cep/{cep}`. Diferencas do ViaCEP: CEP inexistente vem 200
// com `valido: false`; `cep` volta com PONTO ("60.325-440"); `municipio` e aninhado; nao
// existe `complemento`.
export type CepConsulta = {
  cep: string;
  valido: boolean;
  logradouro?: string;
  bairro?: string;
  municipio?: Municipio;
};

export type CepEndereco = {
  logradouro: string;
  bairro: string;
  cidade: string;
  uf: string;
  ufCodigo: string;
  municipioCodigo: string;
};

// `inexistente` (o backend disse `valido: false`) e `indisponivel` (a chamada falhou)
// precisam ser distinguidos: o primeiro barra o Salvar, o segundo nao pode barrar - queda
// de rede nao e motivo para o cliente nao conseguir cadastrar o endereco.
export type CepResultado =
  | { situacao: 'encontrado'; endereco: CepEndereco }
  | { situacao: 'inexistente' }
  | { situacao: 'indisponivel' };

// Exterior. Vem na lista do backend, mas nao ha frete calculavel para fora do pais.
export const UF_EXTERIOR = 'EX';

export function ufListaEntrega(ufs: Uf[]): Uf[] {
  return (ufs || []).filter(uf => uf && uf.sigla !== UF_EXTERIOR);
}

export function ufPorSigla(ufs: Uf[], sigla: string): Uf | null {
  const alvo = (sigla || '').trim().toUpperCase();
  return (ufs || []).find(uf => uf && uf.sigla === alvo) || null;
}
